(() => {
  if (!window.Intl) {
    require.ensure(['intl'], (require) => {
      window.Intl = require('intl');
      window.IntlPolyfill = window.Intl;
      require('./App');
    });
  } else {
    require('./App');
  }
})();



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/